//Libreria para el uso de alertas
import Swal from "sweetalert2";
//Se importa el helper que nos consulta la información de todos los usuarios registrados
import { loadUsers } from "../helpers/loadData";
//Se importan los types de cada acción para usar los que se requieran
import { types } from "../types/types";
//Libreria para las animaciones de Sweetalert2
import "animate.css";
//Método para convertir la hora según la zona horaria indicada
import { getDateCorregidoZonaHoraria } from "./actionsTime";
import { getIP, deleteSuccess } from "./ui";

//Método para editar ciertos campos básicos del usuario registrado en el Sistema
export const editUser = (user, emailAdmin) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("users")
      .doc(`${user.id}`)
      .update({
        nameFirst: user.nameFirst,
        nameSecond: user.nameSecond,
        lastnameFirst: user.lastnameFirst,
        lastnameSecond: user.lastnameSecond,
        typeUser: user.typeUser,
        permissions: user.permissions
      })
      .then(() => {
        getIP().then((response) => {
          enviarLogAdminUpdateUser(
            types.updateUser,
            emailAdmin,
            user.email,
            response.data
          );
        });
      })
      .catch((error) => {
        getIP().then((response) => {
          enviarLogErrorAdminUpdateUser(
            types.updateUser,
            error,
            emailAdmin,
            user.email,
            response.data
          );
        });
      });

    dispatch(startLoadingUsers());

    Swal.fire({
      position: "center",
      icon: "success",
      allowOutsideClick: false,
      title: "Los cambios se han guardado",
      showConfirmButton: false,
      timer: 1000,
    });
  };
};

//Método que inicia la carga de los usuarios
export const startLoadingUsers = () => {
  return async (dispatch) => {
    loadUsers(dispatch);
  };
};

//Método para crear una variable de logo en la BD y Storage
export const createResourceInBD = async (values, closeModal) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  //Se elimina el archivo
  db.collection("config")
    .doc("configApp")
    .collection("logos")
    .doc(values.variable_name)
    .set({
      name: values.name.toUpperCase(),
      url: "",
    })
    .then(() => {
      closeModal("Recurso Agregado con Éxito");
    })
    .catch((error) => {
      // console.error("Error removing document: ", error);
      alertFAIL("Error al Agregar el Recurso");
    });
};

//Método para eliminar una variable de logo en la BD y Storage
export const deleteResourceInDB = (id) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const storage = reduxStore.storage;
    const db = reduxStore.db;

    //Se crea la referencia del archivo en el storage
    const deleteResour = storage.child(`resources_config/${id}`);

    //Se elimina el archivo
    deleteResour
      .delete()
      .then(function () {
        db.collection("config")
          .doc("configApp")
          .collection("logos")
          .doc(id)
          .delete()
          .then(() => {
            alertOK("Recurso Eliminado");
          })
          .catch((error) => {
            // console.error("Error removing document: ", error);
            alertFAIL("Error al Eliminar el Recurso");
          });
      })
      .catch(function (error) {
        // Uh-oh, an error occurred!
        alertFAIL("Error al Eliminar el Recurso");
      });
  };
};

//Método para actualizar una variable de logo en la BD
export const updateResourceInBD = async (values, closeModal) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  db.collection("config")
    .doc("configApp")
    .collection("logos")
    // .collection("logos_marca")
    .doc(values.id)
    .update({
      name: values.name.toUpperCase(),
    }).then(() => {
      closeModal("Recurso Actualizado con Éxito");
    });
};

//Método para crear un recurso de color en la BD
export const createResourceColorInBD = async (values, closeModal) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  db.collection("config")
    .doc("configApp")
    .collection("colores")
    // .collection("colores_marca")
    .doc(values.variable_name)
    .set({
      name: values.name.toUpperCase(),
      code: values.codeColor,
    })
    .then(() => {
      closeModal("Recurso Agregado con Éxito");
    })
    .catch((error) => {
      // console.error("Error removing document: ", error);
      alertFAIL("Error al Agregar el Recurso");
    });
};

//Método para eliminar una variable de logo en la BD y Storage
export const deleteResourceColorInDB = async (id) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  db.collection("config")
    .doc("configApp")
    .collection("colores")
    .doc(id)
    .delete()
    .then(() => {
      alertOK("Recurso Eliminado");
    })
    .catch((error) => {
      // console.error("Error removing document: ", error);
      alertFAIL("Error al Agregar el Recurso");
    });
};

//Método para actualizar una variable de logo en la BD
export const updateResourceColorInBD = async (values, closeModal) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  db.collection("config")
    .doc("configApp")
    .collection("colores")
    // .collection("colores_marca")
    .doc(values.id)
    .update({
      name: values.name.toUpperCase(),
      code: values.codeColor,
    }).then(() => {
      closeModal("Recurso actualizado con éxito");
    });
};

//Método que set los usuarios en el Estado users
export const setUsers = (users) => ({
  type: types.usersLoad,
  payload: users,
});

//Método para iniciar la limpieza del Estado users
export const startClean = () => {
  return async (dispatch) => {
    dispatch(clean());
  };
};

//Método que llama el type para limpiar el Estado users
export const clean = () => ({
  type: types.usersClean,
});

//Método para agregar una derivacion
export const addDerivation = (uid, type) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("derivation")
      .collection("data")
      .add(type)
      .then((doc) => {
        //Realiza la acción que coincida con ese type
        dispatch({ type: types.addDerivation });
        alertOK("Tipo Derivación Agregado");
      })
      .catch((error) => {
        //Realiza la acción que coincida con ese type
        dispatch({ type: types.addDerivation });
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar una derivacion
export const deleteDerivation = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`config/derivation/data/${id}`).delete().then(() => {
      alertOK("Tipo Derivación Eliminado");
    });
  };
};

//Método para editar una derivacion
export const updateDerivation = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("derivation")
      .collection("data")
      .doc(id)
      .update({ name: type }).then(() => {
        alertOK("Tipo Derivación Actualizado");
      });
  };
};

//Método para agregar un nuevo tipo de consulta
export const addTypeConsultation = (uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typeconsultation")
      .collection("data")
      .add(type)
      .then((doc) => {
        alertOK("Tipo Consulta Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de consulta
export const deleteTypeConsultation = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`config/typeconsultation/data/${id}`).delete().then(() => {
      alertOK("Tipo Consulta Eliminado");
    });
  };
};

//Método para editar un tipo de consulta
export const updateTypeConsultation = (id, uid, code, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typeconsultation")
      .collection("data")
      .doc(id)
      .update({ code: code, name: type }).then(() => {
        alertOK("Tipo Consulta Actualizado");
      });
  };
};

//Método para agregar un nuevo tipo de nacionalidad
export const addTypeNationality = (uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("nationality")
      .collection("data")
      .add(type)
      .then((doc) => {
        alertOK("Tipo Nacionalidad Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de nacionalidad
export const deleteTypeNationality = (id, uid, type) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`config/nationality/data/${id}`).delete().then(() => {
      alertOK("Tipo Nacionalidad Eliminado");
    });
  };
};

//Método para editar un tipo de nacionalidad
export const updateTypeNationality = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("nationality")
      .collection("data")
      .doc(id)
      .update({ name: type }).then(() => {
        alertOK("Tipo Nacionalidad Actualizado");
      });
  };
};

//Método para agregar un nuevo pais de residencia
export const addCountryResidence = (uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("residence")
      .collection("data")
      .add(type)
      .then((doc) => {
        alertOK("País Residencia Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un pais de residencia
export const deleteCountryResidence = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`config/residence/data/${id}`).delete().then(() => {
      alertOK("País Residencia Eliminado");
    });
  };
};

//Método para editar un pais de residencia
export const updateCountryResidence = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("residence")
      .collection("data")
      .doc(id)
      .update({ name: type }).then(() => {
        alertOK("País Residencia Actualizado");
      });
  };
};

//Método para agregar un nuevo tipo de DNI
export const typeDniADD = (uid, typeDNI, resetInputs) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesDni")
      .collection("data")
      .add({ ...typeDNI, dateCreate: new Date(), dateUpdate: '' })
      .then((doc) => {
        resetInputs();
        alertOK("Tipo DNI Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de DNI
export const typeDniDELETE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesDni")
      .collection("data")
      .doc(id).delete().then(() => {
        deleteSuccess();
      }).catch((error) => {
        console.error("Error removing document: ", error);
      });
  };
};

//Método para editar un pais de DNI
export const typeDniUPDATE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typesDni")
      .collection("data")
      .doc(id)
      .update({ ...type, dateUpdate: new Date() }).then(() => {
        alertOK("Tipo DNI Actualizado");
      });
  };
};


//Método para agregar un nuevo tipo de orientación sexual
export const typeOrientationADD = (uid, typeOrientation, clearInputs) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesOrientation")
      .collection("data")
      .add({ ...typeOrientation, dateCreate: new Date(), dateUpdate: '' })
      .then((doc) => {
        clearInputs();
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de orientación sexual
export const typeOrientationDELETE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesOrientation")
      .collection("data")
      .doc(id).delete().then(() => {
        deleteSuccess();
      }).catch((error) => {
        console.error("Error removing document: ", error);
      });
  };
};

//Método para editar un tipo de orientación sexual
export const typeOrientationUPDATE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typesOrientation")
      .collection("data")
      .doc(id)
      .update({ ...type, dateUpdate: new Date() }).then(() => {
        alertOK("Tipo Orientación Sexual Actualizado");
      });
  };
};


//Método para agregar un nuevo tipo de etnia
export const typeEthnicADD = (uid, typeEthnic, clearInputs) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesEthnic")
      .collection("data")
      .add({ ...typeEthnic, dateCreate: new Date(), dateUpdate: '' })
      .then((doc) => {
        clearInputs();
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de etnia
export const typeEthnicDELETE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesEthnic")
      .collection("data")
      .doc(id).delete().then(() => {
        deleteSuccess();
      }).catch((error) => {
        console.error("Error removing document: ", error);
      });
  };
};

//Método para editar un tipo de etnia
export const typeEthnicUPDATE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typesEthnic")
      .collection("data")
      .doc(id)
      .update({ ...type, dateUpdate: new Date() }).then(() => {
        alertOK("Tipo Etnia Actualizada");
      });
  };
};


//Método para agregar un nuevo tipo de grupo poblacional
export const typePopulationADD = (uid, typePopulation, clearInputs) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesPopulation")
      .collection("data")
      .add({ ...typePopulation, dateCreate: new Date(), dateUpdate: '' })
      .then((doc) => {
        clearInputs();
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de grupo poblacional
export const typePopulationDELETE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.collection("config")
      .doc("typesPopulation")
      .collection("data")
      .doc(id).delete().then(() => {
        deleteSuccess();
      }).catch((error) => {
        console.error("Error removing document: ", error);
      });
  };
};

//Método para editar un tipo de grupo poblacional
export const typePopulationUPDATE = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typesPopulation")
      .collection("data")
      .doc(id)
      .update({ ...type, dateUpdate: new Date() }).then(() => {
        alertOK("Tipo Grupo Poblacional Actualizado");
      });
  };
};

//Método para agregar un nuevo tipo de plan medico
export const addMedicalPlan = (uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("medical_plan")
      .collection("data")
      .add(type)
      .then((doc) => {
        alertOK("Plan Médico Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Plan Médico");
      });
  };
};

//Método para eliminar un tipo de plan medico
export const deleteMedicalPlan = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`config/medical_plan/data/${id}`).delete().then(() => {
      alertOK("Plan Médico Eliminado");
    });
  };
};

//Método para editar un tipo de plan medico
export const updateMedicalPlan = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("medical_plan")
      .collection("data")
      .doc(id)
      .update({ name: type }).then(() => {
        alertOK("Plan Médico Actualizado");
      });
  };
};

//Método para agregar un nuevo tipo de derivacion
export const addTypesDerivation = (uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typesderivation")
      .collection("data")
      .add(type)
      .then((doc) => {
        alertOK("Tipo Derivación Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Tipo");
      });
  };
};

//Método para eliminar un tipo de derivacion
export const deleteTypeDerivation = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`config/typesderivation/data/${id}`).delete().then(() => {
      alertOK("Tipo Derivación Eliminado");
    });
  };
};

//Método para editar un tipo de derivacion
export const updateTypeDerivation = (id, uid, type) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("config")
      .doc("typesderivation")
      .collection("data")
      .doc(id)
      .update({ name: type }).then(() => {
        alertOK("Tipo Derivación Actualizado");
      });
  };
};

/////////////////////////////////////////////////////MÉTODOS PARA ADMINISTRAR LA AGENDA/////////////////////////////////////////////////////

export const addSpecialtySchedule = (uid, specialty) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("specialty")
      .doc(specialty.code)
      .set(specialty)
      .then((doc) => {
        alertOK("Especialidad Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Servicio");
      });
  };
};

export const updateSpecialtySchedule = (uid, id, specialty) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("specialty")
      .doc(id)
      .update({
        ...specialty,
        orderSpecialty: parseInt(specialty.orderSpecialty),
      }).then(() => {
        alertOK("Especialidad Actualizado");
      });
  };
};

export const deleteSpecialtySchedule = (uid, id, specialty) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`specialty/${id}`).delete().then(() => {
      alertOK("Especialidad Eliminada");
    });
  };
};

export const addServiceSchedule = (uid, service) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("service")
      .doc(service.code)
      .set(service)
      .then((doc) => {
        alertOK("Servicio Agregado");
      })
      .catch((error) => {
        alertFAIL("No se pudo Agregar el Servicio");
      });
  };
};

export const updateServiceSchedule = (uid, id, service) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("service")
      .doc(id)
      .update({ ...service }).then(() => {
        alertOK("Servicio Actualizado");
      });
  };
};

export const deleteServiceSchedule = (uid, id, service) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db.doc(`service/${id}`).delete().then(() => {
      alertOK("Servicio Eliminado");
    });
  };
};

export const addProfessionalSchedule = (professional, resetInputProfessional) => {
  const { text, services, servicesFinal, ...rest } = professional;

  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("professional")
      .doc(professional.uid)
      .set({ ...rest, services: [...servicesFinal] })
      .then((doc) => {
        // resetInputProfessional();
        alertOK("Profesional Agregado");
      })
      .catch((error) => {
        console.log(error)
        alertFAIL("No se pudo Agregar el profesional");
      });
  };
};
// export const addProfessionalNewSchedule = async (values, oldValues, edit) => {
export const addProfessionalNewSchedule = (values, edit) => {
  const { text, services, ...rest } = values;
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("professional")
      .doc(values.uid.trim())
      .set({ ...rest, services })
      .then(() => {
        alertOK(`Profesional ${edit ? 'Actualizado' : 'Agregado'}`);
      })
      .catch((error) => {
        console.log(error)
        alertFAIL(`No se pudo ${edit ? 'Actualizar' : 'Agregar'} el Profesional`);
      });
  };

  // const refProfessional = db.collection("professional").doc(values.uid.trim());
  // const refProfessionalLog = db.collection("logProfessional").doc();


  // const batch = db.batch();
  // batch.set(refProfessional, {
  //   ...rest, services
  // });
  // batch.set(refProfessionalLog, {
  //   ...oldValues
  // });
  // batch.commit().then(() => {
  //   alertOK(`Profesional ${edit ? 'Actualizado' : 'Agregado'}`);
  // }).catch(() => {
  //   alertFAIL(`No se pudo ${edit ? 'Actualizar' : 'Agregar'} el Profesional`);
  // });
};

export const blockProfessionalSchedule = (email, values, emailProfessional) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("schedule")
      .doc(
        `${new Date(
          values.dateBlock
        ).getTime()}_${values.professionalBlock.value.replace("-", "")}`
      )
      .set({
        patientName: "",
        patientRut: "",
        patientPhone: "",
        patientPhoneCode: "",
        patientEmail: "",
        patientBirthDay: "",
        patientPassword: "",

        professionalName: values.professionalBlock.label.toUpperCase(),
        professionalRut: values.professionalBlock.value.toUpperCase(),
        professionalEmail: emailProfessional,

        payOrder: "0",
        payStatus: "success",
        payVerificationKey: "",
        payTransactionKey: "",
        payPaymentKey: "",
        payTransactionId: "",

        prevision: "",

        scheduleSpecialty: "Horario bloqueado",

        serviceCode: "",
        serviceCodeAlternative: "0",
        serviceDuration: values.durationBlock,
        serviceName: "Bloqueo",

        schedulePrice: "",
        scheduleCountry: "",

        idDocument: `${new Date(
          values.dateBlock
        ).getTime()}_${values.professionalBlock.value.replace("-", "")}`,
        urlDate: "",
        timeZone: values.timeZone,
        timeStart: new Date(values.dateBlock),
        timeLocal: new Date(values.dateBlock),
        createDate: new Date(),
        timeEnd: "",
        timePatient: "",
        timeDoctor: "",
        timestamp: new Date(values.dateBlock).getTime(),
        codeValidation: false,
      })
      .then(() => {
        dispatch({ type: types.blockProfessionalSchedule });

        getIP().then((response) => {
          console.log(response);
          enviarLogAdminProf(
            types.blockProfessionalSchedule,
            email,
            emailProfessional,
            response.data
          );
        });
        alertOK("Agenda bloqueada");
      })
      .catch((error) => {
        dispatch({ type: types.blockProfessionalSchedule });

        getIP().then((response) => {
          console.log(response);
          enviarLogErrorAdminBlockProf(
            types.blockProfessionalSchedule,
            error,
            email,
            emailProfessional,
            response.data
          );
        });
        alertFAIL("No se pudo Agregar el profesional");
      });
  };
};

export const blockScheduleProfessional = (email, values, emailProfessional, resetInputBlock) => {
  return async () => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    const startTimeBlockSplit = values.dateStartBlock
      .replaceAll("-", " ")
      .replaceAll("T", " ")
      .replaceAll(":", " ")
      .split(" ");
    const startTimeBlock = new Date(
      startTimeBlockSplit[0],
      startTimeBlockSplit[1] - 1,
      startTimeBlockSplit[2],
      startTimeBlockSplit[3],
      startTimeBlockSplit[4],
      0
    );
    const startTimeBlockCorrect = getDateCorregidoZonaHoraria(
      startTimeBlock,
      values.timeZone.timeZone
    );

    const endTimeBlockSplit = values.dateEndBlock
      .replaceAll("-", " ")
      .replaceAll("T", " ")
      .replaceAll(":", " ")
      .split(" ");
    const endTimeBlock = new Date(
      endTimeBlockSplit[0],
      endTimeBlockSplit[1] - 1,
      endTimeBlockSplit[2],
      endTimeBlockSplit[3],
      endTimeBlockSplit[4],
      0
    );
    const endTimeBlockCorrect = getDateCorregidoZonaHoraria(
      endTimeBlock,
      values.timeZone.timeZone
    );

    const mapBlock = {
      // [endTimeBlock.getTime().toString()]: {
      [endTimeBlockCorrect.getTime().toString()]: {
        start: startTimeBlockCorrect,
        end: endTimeBlockCorrect,
        timeZone: values.timeZone.timeZone,
      },
    };

    await db
      .collection("professional")
      .doc(values.professionalBlock.uid)
      .update({
        block: { ...values.professionalBlock.block, ...mapBlock },
      })
      .then(() => {
        resetInputBlock();
        alertOK("Bloqueo realizado con Éxito");
      })
      .catch((err) => {
        alertFAIL("No se pudo guardar Bloqueo");
      });
  };
};

export const updateProfessionalSchedule = (email, id, professional) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .collection("professional")
      .doc(id)
      .update(professional)
      .then(() => {
        dispatch({ type: types.updateProfessionalSchedule });

        getIP().then((response) => {
          enviarLogAdminProf(
            types.updateProfessionalSchedule,
            email,
            professional.name,
            response.data
          );
        });
        alertOK("Profesional Actualizado");
      })
      .catch((error) => {
        dispatch({ type: types.blockProfessionalSchedule });

        getIP().then((response) => {
          enviarLogErrorAdminBlockProf(
            types.blockProfessionalSchedule,
            error,
            email,
            professional.name,
            response.data
          );
        });
        alertFAIL("No se pudo Actualizar el Profesional");
      });
  };
};

export const deleteProfessionalSchedule = (email, id, professional) => {
  return async (dispatch) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const db = reduxStore.db;

    await db
      .doc(`professional/${id}`)
      .delete()
      .then(() => {
        dispatch({ type: types.deleteProfessionalSchedule });

        getIP().then((response) => {
          console.log(response);
          enviarLogAdminProf(
            types.updateProfessionalSchedule,
            email,
            professional,
            response.data
          );
        });
        alertOK("Profesional Eliminado");
      })
      .catch((error) => {
        dispatch({ type: types.deleteProfessionalSchedule });
        getIP().then((response) => {
          console.log(response);
          enviarLogErrorAdminBlockProf(
            types.blockProfessionalSchedule,
            error,
            email,
            professional,
            response.data
          );
        });
        alertFAIL("No se pudo Actualizar el Profesional");
      });
  };
};

/////////////////////////////////////////////////////MÉTODOS PARA ADMINISTRAR LA AGENDA/////////////////////////////////////////////////////

/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////

//Método para guardar el Log de Admin al actualizar un usuario
const enviarLogAdminUpdateUser = async (action, email, emailUserUpd, IP) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log").add({
    log_date: date,
    action: action,
    user: email,
    userUpdate: emailUserUpd,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log error de Admin al actualizar un usuario
const enviarLogErrorAdminUpdateUser = async (
  action,
  error,
  email,
  emailUserUpd,
  IP
) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").add({
    log_date: date,
    action: action,
    error: error,
    user: email,
    userUpdate: emailUserUpd,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log al bloquear una hora
const enviarLogAdminProf = async (action, email, emailProf, IP) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log").add({
    log_date: date,
    action: action,
    user: email,
    professional: emailProf,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

//Método para guardar el Log Error al bloquear una hora
const enviarLogErrorAdminBlockProf = async (action, error, email, emailProf, IP) => {
  const { getReduxStore } = await import('../helpers/reduxInstance');
  const reduxStore = await getReduxStore();
  const db = reduxStore.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log").add({
    log_date: date,
    action: action,
    error: error,
    user: email,
    professional: emailProf,
    ip: IP.IPv4,
    country: IP.country_name,
  });
};

/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////

/////////////////////////////////////////////////////MÉTODOS PARA ALERTAS/////////////////////////////////////////////////////
//Método para la alerta cuando fue con éxito una acción
export const alertOK = (msg) => {
  Swal.fire({
    position: "center",
    icon: "success",
    title: msg,
    showConfirmButton: false,
    allowOutsideClick: false,
    timer: 2000,
    showClass: {
      popup: "animate__animated animate__fadeInUp",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown",
    },
  });
};

//Método para la alerta cuando fracasó una acción
export const alertFAIL = (msg) => {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: msg,
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown",
    },
  });
};

export const alertQuestion = (title, text, functionAccept) => {
  Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      functionAccept()
    }
  });
};
/////////////////////////////////////////////////////MÉTODOS PARA ALERTAS/////////////////////////////////////////////////////
